import React, { useState } from 'react';
import faqImg from '../../../assets/faqImg.jpeg';
import ActionIconItem from './action-icon-item';

export default function LandingAskUsPage() {

    const [expandedIndex, setExpandedIndex] = useState(null);

    const handleToggle = (index) => {
        if (expandedIndex === index) {
            setExpandedIndex(null);
        } else {
            setExpandedIndex(index);
        }
    };

    return (
        <div className="mx-16 xl:m-auto max-w-7xl pb-28 max-xs:mx-6">
            <div className="flex flex-col items-center">
                <div className="text-center pt-24 pb-16">
                    <h2 className="font-sans font-extrabold text-4xl xl:text-5xl bg-gradient-to-r from-gray-900 via-primary-700 to-[#F482C0] bg-clip-text text-transparent pb-2">
                        Frequently Asked Questions
                    </h2>
                </div>

                <div className='flex items-start gap-12 xl:gap-20 max-lg:flex-col items-center justify-center w-full'>
                    <div className="shrink-0">
                        <img className='w-[400px] h-auto xl:w-[500px] rounded-3xl shadow-xl hover:shadow-2xl transition-shadow duration-500' src={faqImg} alt='faq img' />
                    </div>

                    <div className="flex flex-col gap-6 w-full max-w-3xl">
                        <ActionIconItem
                            index={0}
                            isExpanded={expandedIndex === 0}
                            toggleAccordion={handleToggle}
                            title="Can I get paid collaborations through Oye Creators?"
                            content="Yes, you get only paid or barter collaborations through Oye Creators. Say goodbye to freebies."
                        />
                        <ActionIconItem
                            index={1}
                            isExpanded={expandedIndex === 1}
                            toggleAccordion={handleToggle}
                            title="How much money can a creator earn with one reel?"
                            content="A creator can earn a minimum of ₹500 and a maximum of ₹5000 from one reel. Also, the pricing will depend on your Creator Scores."
                        />
                        <ActionIconItem
                            index={2}
                            isExpanded={expandedIndex === 2}
                            toggleAccordion={handleToggle}
                            title="Do you have creators who can do barter collaborations?"
                            content="Yes, we have some creators who do barter, but it depends on what they are getting in exchange. It is entirely up to them if they want to do barter or not. We don't restrict our creators."
                        />
                        <ActionIconItem
                            index={3}
                            isExpanded={expandedIndex === 3}
                            toggleAccordion={handleToggle}
                            title="Is there any criterion for subscription or platform fees?"
                            content="No, we are a no-commission platform, and as we follow outcome-based pricing, we don't have any subscription plans."
                        />
                        <ActionIconItem
                            index={4}
                            isExpanded={expandedIndex === 4}
                            toggleAccordion={handleToggle}
                            title="I am a fresher with less than 1k followers, can I register?"
                            content="Yes, you can. We always welcome freshers and would appreciate it if they want to grow with us."
                        />
                        <ActionIconItem
                            index={5}
                            isExpanded={expandedIndex === 5}
                            toggleAccordion={handleToggle}
                            title="I have a private account, can I also get projects?"
                            content="You can sign up with us, but getting a project is not guaranteed for you because Oye Creators post all the reels in collaboration, which in the case of private profiles, is restricted."
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
